import { AlertCircle } from "lucide-react";
import {
  Text,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@musa.tech/design-system";

interface MtrCellProps {
  /** `null`/`undefined` = falha ao carregar; `[]` = sem MTR emitido; populado = um ou mais números. */
  mtrNumbers: string[] | null | undefined;
}

export function MtrCell({ mtrNumbers }: MtrCellProps) {
  if (mtrNumbers == null) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span tabIndex={0} className="inline-flex cursor-default">
              <AlertCircle
                className="h-4 w-4 text-neutral-400"
                aria-label="MTR indisponível no momento"
              />
            </span>
          </TooltipTrigger>
          <TooltipContent>Não foi possível carregar o MTR agora.</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  if (mtrNumbers.length === 0) {
    return (
      <Text variant="body" size="small" className="text-neutral-400">
        —
      </Text>
    );
  }

  return (
    <div className="flex flex-col gap-0.5">
      {mtrNumbers.map((number) => (
        <Text key={number} variant="body" size="small" className="text-neutral-900">
          {number}
        </Text>
      ))}
    </div>
  );
}
